import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImageViewerComponent } from 'src/app/shared/components/image-viewer/image-viewer.component';
import { Chunk } from '../../chunk.dto';

@Component({
  selector: 'app-image-chunk-displayer',
  standalone: true,
  imports: [ImageViewerComponent],
  template: `
    @if (chunk(); as chunk) {
      <div class="image-container">
        <app-image-viewer [src]="chunk.imageURL" [alt]="chunk.imageDescription" borderRadius="8px" [enableZoom]="true" [disableTouchMove]="true"></app-image-viewer>
      </div>
      @if (chunk.imageDescription) {
        <div class="description">
          {{ chunk.imageDescription }}
        </div>
      }
    }
  `,
  styles: [
    `
      .description {
        font-size: small;
        margin-top: 8px;
        text-align: center;
        color: #6b7280;
      }
      .image-container {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        background-color: var(--skz-background-color-surface);
        border-radius: 8px;
      }
      
      ::ng-deep .image-container app-image-viewer {
        width: 100%;
      }
      
      ::ng-deep .image-container app-image-viewer img {
        max-height: 60vh;
        object-fit: contain !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageChunkDisplayerComponent {
  chunk = input.required<Chunk>();
}
